import { render, staticRenderFns } from "./AlphanumericFormatView.vue?vue&type=template&id=b312f8fc&"
import script from "./AlphanumericFormatView.vue?vue&type=script&lang=js&"
export * from "./AlphanumericFormatView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports